import React from "react";
import { useMediaQuery } from "@mui/material";
import LoginWeb from "./LoginWeb";
import LoginMobile from "./LoginMobile";

const Login = () => {
  const isSmallScreen = useMediaQuery("(max-width:1200px)");

  return isSmallScreen ? (<main>
    <LoginMobile />
    </main>

  ) : (
    <main>
      <LoginWeb />
    </main>
  );
};

export default Login;
